/* eslint-disable jsx-a11y/anchor-is-valid */
import { Component } from "react";
import {set_datapage, SetLanguage, getLanguage} from '@ora/recursos/src/redux/actions/DataPageAction'
import numeral from "numeral";
import { connect } from "react-redux";
import { MultiSelect } from "react-selectize";
import { styleInfo } from "./info";
import MTDDetallesBase from "./MTDDetallesBase";
import Select from 'react-select';




class FITValoEstiUSDTipProdEsp extends Component {
  state = {
    body: [],
    modals: [],
    selectedProducts:[]
  }

  componentDidMount () {
  
    this.generate(this.props.data.rows)
  }
  onChangeMultiselec=(selectedProducts)=>{
    if(selectedProducts.length>0){
      let output = this.props.data.rows.filter(eachVal => {
        let opt = eachVal.data.some((
            { codigo }) => selectedProducts.some(({value})=>codigo.includes(value)));
        return opt;
      })
      output= output.map( function( row ) {
        return {'especie':row.especie,"data":row.data.filter( function( item ) {
            return selectedProducts.some(({value})=>item.codigo.includes(value))
        } )};
      } )
      this.generate(output)
    }else{
      this.generate(this.props.data.rows)
    }

  }
  generate = (data) => {
    //numeral.locale('es-ES')
    let rowsN = [], modalsN = [], rowsF = [], modalsF = []
    let textTarget = 'FITValoEstiUSDTipProdEsp'
    let indexKey = 0

    data.forEach((item, index) => {

      textTarget += index    

      rowsN.push(
        <>
      <tr key={ ++indexKey } draggable="false" className="" style={{background: '#dfcfea'}}>
        <td className="" colSpan="7">{ item.especie }</td>
      </tr>
        { item.data.map((itemD, indexD) => {
          modalsN.push(<MTDDetallesBase 
            title={ itemD.codigo }
            key={ indexD } 
            id={ textTarget + 'N' + indexD} 
            data={ itemD.n.data } />)

       

          return  <tr key={ ++indexKey } draggable="false" className="">
            <td className="">{ itemD.codigo }</td>
            <td className="has-text-centered">
            <a href="" 
                data-target={ textTarget + 'N' + indexD} 
                style={{
                  borderBottom: '1px dotted black'
                }}
                onClick={ e => {
                  e.preventDefault()
                  if (itemD.n.value > 0)
                    document.getElementById(e.target.dataset.target).classList.add('is-active')
                } } 
              >
                { numeral(itemD.n.value).format('0.0') }
              </a>
            </td>
            
            <td className="has-text-centered">{ numeral(itemD.promedio).format('0,0.00') }</td>
            <td className="has-text-centered">{ numeral(itemD.mediana).format('0,0.00') }</td>
            <td className="has-text-centered">{ numeral(itemD.min).format('0,0.00') }</td>
            <td className="has-text-centered">{ numeral(itemD.max).format('0,0.00') }</td>
          </tr>
        })}
        </>
      )


    

    })

    this.setState({
      body: rowsN,
      modals: modalsN,
      // modalsF: modalsF
    })
     
  }
  render () {
   //[{year: 2002, value: 10.5}]
    let indexKey = 0
    return this.props.data.rows.length > 0 ? 
    <div style={{fontSize: '0.9em'}}>
    <div className="has-text-centered mb-1" style={{fontSize: '0.9em'}}>

      <p style={{
            color: '#000',
            fontSize: '1.4em',
            fontWeight: 'bold',
            fill: '#000'
      }}>{ this.props.title }</p>
      </div>
      <Select
      closeMenuOnSelect={true}
      //defaultValue={[this.data[4], this.data[5]]}
      isMulti
      options={this.props.data.product}
      placeholder = "Seleccione al menos un producto para filtrar la tabla"
      onChange = {this.onChangeMultiselec}
    />
    <div className="table-wrapper has-mobile-cards table-container mt-1">
      <table className="table db-trafico is-striped is-hoverable">
        <thead>
          <tr>
            
            <th draggable="false" className="is-sortable is-unselectable is-current-sort">
              <div className="th-wrap has-text-centered"><span className="is-relative">&nbsp;</span></div>
            </th>
            <th draggable="false" className="is-sortable is-unselectable">
              <div className="th-wrap has-text-centered"><span className="is-relative has-text-centered">N</span>
              &nbsp;
              <span className="has-tooltip-bottom has-tooltip-multiline"  data-tooltip="N: Número de registros utilizados con datos de valores en los especímenes">
                  <i className="fas fa-info-circle"  style={ styleInfo }></i>
              </span>
              
              </div>
            </th>
           
            <th draggable="false" className="">
              <div className="th-wrap has-text-centered"><span className="is-relative has-text-centered">Promedio <br/>(USD) </span></div>
            </th>
            <th draggable="false" className="">
              <div className="th-wrap has-text-centered"><span className="is-relative has-text-centered">Mediana <br/>(USD)</span></div>
            </th>
            <th draggable="false" className="">
              <div className="th-wrap has-text-centered"><span className="is-relative has-text-centered">Min <br/>(USD)</span></div>
            </th>
            <th draggable="false" className="">
              <div className="th-wrap has-text-centered"><span className="is-relative has-text-centered">Max <br/>(USD)</span></div>
            </th>
          </tr>
        </thead>
        <tbody>
          { this.state.body }
        </tbody>
        { this.state.modals }
        
      </table>
      
    </div>
    <div className="has-text-centered" style={{fontSize: '0.9em'}}>
        <p className="px-6" style={{
              color: '#000',
              fontSize: '1.1em',
              
              fill: '#000'
        }}><i>{ this.props.description }</i></p>
        </div>
    </div>
    : null
    
  }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(FITValoEstiUSDTipProdEsp)